import * as React from 'react';
import { useState, useMemo } from 'react';
import { ListBase } from 'react-admin';
import {
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    startOfDay,
    endOfDay,
    subWeeks,
    addWeeks,
} from 'date-fns';
import { MissionCalendarLayout } from './MissionCalendarLayout';

export type CalendarMode = 'month' | 'week' | 'day';

export const MissionCalendar = () => {
    const [anchorDate, setAnchorDate] = useState<Date>(new Date());
    const [mode, setMode] = useState<CalendarMode>('month');

    const { rangeStart, rangeEnd } = useMemo(() => {
        let start: Date;
        let end: Date;
        if (mode === 'month') {
            start = startOfMonth(anchorDate);
            end = endOfMonth(anchorDate);
        } else if (mode === 'week') {
            start = startOfWeek(anchorDate, { weekStartsOn: 1 });
            end = endOfWeek(anchorDate, { weekStartsOn: 1 });
        } else {
            start = startOfDay(anchorDate);
            end = endOfDay(anchorDate);
        }
        return { rangeStart: start, rangeEnd: end };
    }, [anchorDate, mode]);

    // Filter to fetch missions starting up to 1 week before rangeStart and 1 week after rangeEnd
    // This ensures padding days in the calendar views (like previous/next month days) have their missions fetched.
    const filter = useMemo(
        () => ({
            status: 'not.in.(archived,cancelled)',
            startDate: {
                lte: addWeeks(rangeEnd, 1).toISOString(),
                gte: subWeeks(rangeStart, 1).toISOString(),
            },
        }),
        [rangeStart, rangeEnd]
    );

    return (
        <ListBase
            resource="mission"
            perPage={10000}
            sort={{ field: 'startDate', order: 'ASC' }}
            filter={filter}
        >
            <MissionCalendarLayout
                anchorDate={anchorDate}
                setAnchorDate={setAnchorDate}
                mode={mode}
                setMode={setMode}
                rangeStart={rangeStart}
                rangeEnd={rangeEnd}
            />
        </ListBase>
    );
};
